module.exports = __webpack_public_path__ + "static/media/groups-active.943179b2.svg";